import ImageOptimizer from '@/components/image-optimizer';
import { slugify } from '@/lib/utils';
import { StoreEntity, StoreType } from '@/services/types/store.type';
import Link from 'next/link';

interface BranchCarouselCardProps {
  branch: StoreEntity;
}

const BranchCarouselCard = ({ branch }: BranchCarouselCardProps) => {
  const branchSlug = slugify(branch.name, branch.id);

  return (
    <Link href={`/branch/${branchSlug}`} className="w-full">
      <div className="desktop:h-[200px] desktop:m-3 m-2 box-border flex h-[150px] overflow-hidden rounded-lg border border-[#111111]/10 bg-white shadow-md transition">
        <div className="desktop:block hidden">
          <div className="desktop:w-[240px] relative h-full shrink-0 overflow-hidden">
            <ImageOptimizer
              src={branch.photoPath}
              alt={branch.name + ' 썸네일'}
              fill
              className="object-cover"
            />
          </div>
        </div>

        {/* 2. 오른쪽 정보 섹션 */}
        <div className="desktop:px-6 desktop:pt-8 flex flex-1 flex-col justify-between bg-white px-5 py-6">
          <div className="flex flex-col">
            {/* 제목 + 직영점 태그 */}
            <div className="desktop:mb-3 mb-2 flex items-center gap-2">
              <h3 className="desktop:typo-24 typo-18 text-level-1 truncate font-extrabold">
                {branch.name}
              </h3>
              {branch?.type === StoreType.DIRECT && (
                <span className="bg-main-yellow text-level-1 desktop:typo-14 typo-12 shrink-0 rounded-sm px-2 py-1 text-center leading-[15px] font-bold">
                  직영점
                </span>
              )}
            </div>

            {/* 주소 */}
            <div className="desktop:typo-18 typo-15 text-level-4 flex items-start gap-1 font-bold">
              <div className="desktop:mt-[3px] relative mt-[2px] size-4 shrink-0">
                <ImageOptimizer
                  src="/images/icons/icon_map_pin.svg"
                  alt="위치"
                  fill
                />
              </div>
              <p className="leading-snug">{branch.address}</p>
            </div>
          </div>

          {/* 해시태그 - 최대 2개만 표시 */}
          {branch.keywordTags && branch.keywordTags.length > 0 && (
            <div className="flex flex-wrap gap-1.5">
              {branch.keywordTags
                .split(',')
                .slice(0, 2)
                .map((keyword) => (
                  <span
                    key={keyword}
                    className="text-font-grayblue desktop:typo-14 typo-12 rounded-lg bg-gray-100 px-3 py-2 font-semibold"
                  >
                    #{keyword}
                  </span>
                ))}
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};

export default BranchCarouselCard;
